module.exports = __webpack_public_path__ + "img/icon_word.b272ee1d.svg";